import React from 'react';

import Modal from 'antd/es/modal/Modal';

import '@app/scss/components/bookingModal.scss';

interface BookingModalProps {
	open: boolean;
	title: React.ReactNode;
	buttonText: React.ReactNode;
	children: React.ReactNode;
	onOk: () => void;
	modalClassName?: string;
}

const BookingModal: React.FC<BookingModalProps> = ({
	open,
	title,
	buttonText,
	children,
	onOk,
	modalClassName = '',
}) => {
	return (
		<Modal
			className={`booking-modal ${modalClassName}`}
			open={open}
			title={title}
			footer={typeof buttonText === 'string' ? (
				<button className="btn btn-md btn-primary" onClick={onOk}>
					{buttonText}
				</button>
			) : buttonText}
			closable={false}
		>
			{children}
		</Modal>
	);
};

export default BookingModal;
